module.exports = __webpack_public_path__ + "img/shoot_00010.62eac7dc.png";